import { Component, OnDestroy, ElementRef, OnInit, ViewChild, OnChanges, SimpleChanges, ChangeDetectorRef, Injectable, ChangeDetectionStrategy } from '@angular/core';
import { moveItemInArray, transferArrayItem, CdkDragDrop } from '@angular/cdk/drag-drop';
import { ViewportScroller } from '@angular/common';
import { Location } from '@angular/common'
import { Subject, Observable, BehaviorSubject, ReplaySubject } from 'rxjs';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { TableModule } from 'primeng/table';
import { DailySales } from '../classes/reports';
import { DomSanitizer } from '@angular/platform-browser';
import { map, takeUntil } from 'rxjs/operators';

import { Message } from '../classes/message';
import { UntypedFormBuilder, FormGroup } from '@angular/forms';
import { GlobalSearchService } from '../services/globalsearchservice.service';
import { GlobalsService } from '../services/globals.service';
import { PrintService } from '../services/print.service';
import { UsersService } from '../services/users.service';
import { DashboardService } from '../services/dashboard.service';
import { ReportsService } from 'app/services/reports.service';

import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import * as Chartist from 'chartist';
import { Directive, HostListener, ViewEncapsulation } from '@angular/core';
import { trigger, state, style, transition, animate, query, group, stagger } from '@angular/animations';

import { Chart, registerables } from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';

import autocolors from 'chartjs-plugin-autocolors';
import { OrdersService } from 'app/services/orders.service';
import { buildDashboardThemeVars } from '../shared/dashboard-widget-theme';
Chart.register(autocolors);


@Component({
	selector: 'app-dashboard',
	templateUrl: './dashboard.component.html',
	styleUrls: ['./dashboard.component.scss'],
	animations: [
		trigger('flipState', [
			state('active', style({
				// transform: 'rotateY(179deg)',
				//safari does not like rotate Yputting the d
				transform: 'rotate3d(0, 1, 0, 179deg)',
			})),
			state('inactive', style({
				transform: 'rotateY(0)'
			})),
			state('orderlookup', style({
				transform: 'rotate3d(0, 1, 0, 179deg)',
			})),
			transition('active => inactive', animate('400ms ease-out')),
			transition('inactive => active', animate('400ms ease-in')),
			transition('inactive => orderlookup', animate('400ms ease-out')),
			transition('orderlookup => inactive', animate('400ms ease-in')),
		]),
		trigger('openClose', [
			state(':enter', style({ height: '*' })),
			state(':leave', style({ height: '0px' })),
			transition('false <=> true', animate(500))
		]),
		trigger('filterAnimation', [
			transition(':enter, * => 0, * => -1', []),
			transition(':increment', [
				query(':enter', [
					style({ opacity: 0, width: 0 }),
					stagger(50, [
						animate('300ms ease-out', style({ opacity: 1, width: '*' })),
					]),
				], { optional: true })
			]),
			transition(':decrement', [
				query(':leave', [
					stagger(50, [
						animate('300ms ease-out', style({ opacity: 0, width: 0 })),
					]),
				])
			]),
		]),
		trigger('grow', [ // Note the trigger name
			transition(':enter', [
				// :enter is alias to 'void => *'
				style({ height: '0', width: '0' }),
				animate(200, style({ height: '*', width: '*' })),
				animate('200ms', style({ opacity: 1 })),
			]),
			transition(':leave', [
				// :leave is alias to '* => void'
				animate(100, style({ height: 0, width: 0, overflow: 'hidden' })),
				animate('100ms', style({ opacity: 0 }))
			])
		]),
	]
})
export class DashboardComponent implements OnInit {
	@ViewChild('monthView') monthViewRef: ElementRef;
	@ViewChild('print_table') printtable: ElementRef;
	@ViewChild('catChartRef') catChartRef!: ElementRef < HTMLCanvasElement > ;
	@ViewChild('customerTypeChartRef', { static: false }) customerTypeChartRef!: ElementRef < HTMLCanvasElement > ;
	customerTypeSales: any = [];

	// ── Customer-type donut state (replaces Chart.js render) ────────────────
	customerTypeSlices: { label: string; value: number; qty: number; pct: number; color: string; dashLength: number; dashOffset: number }[] = [];
	hoveredCustomerTypeSlice: number | null = null;
	ctView: 'chart' | 'table' = 'chart';
	ctDays: number = 7;
	readonly ctDayPresets: { label: string; value: number }[] = [
		{ label: '7d',  value: 7 },
		{ label: '14d', value: 14 },
		{ label: '30d', value: 30 },
		{ label: '90d', value: 90 },
		{ label: '1y',  value: 365 },
	];
	ctShowRangePicker = false;
	/** True once a custom from/to range has been applied (presets are then inactive). */
	ctCustom = false;
	/** True while the from/to fields are expanded in the range popover. */
	ctCustomOpen = false;
	ctCustomFrom: Date | null = null;
	ctCustomTo: Date | null = null;
	toggleCtView(): void { this.ctView = this.ctView === 'chart' ? 'table' : 'chart'; }
	toggleCtRangePicker(): void {
		this.ctShowRangePicker = !this.ctShowRangePicker;
		if (this.ctShowRangePicker && this.ctCustom) { this.ctCustomOpen = true; }
	}
	/** Subtitle caption: preset day count, or the applied custom range. */
	get ctRangeLabel(): string {
		if (this.ctCustom && this.ctCustomFrom && this.ctCustomTo) {
			const opts: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'short', day: 'numeric' };
			return `${this.ctCustomFrom.toLocaleDateString(undefined, opts)} \u2013 ${this.ctCustomTo.toLocaleDateString(undefined, opts)}`;
		}
		return this.days ? `Last ${this.days} days` : '';
	}
	setCtDays(d: number): void {
		if (d === this.ctDays && !this.ctCustom) { this.ctShowRangePicker = false; return; }
		this.ctDays = d;
		this.ctCustom = false;
		this.ctCustomOpen = false;
		this.ctShowRangePicker = false;
		this.refreshCustomerType();
	}
	/** Expand/collapse the custom from/to fields, seeding them from the current preset. */
	toggleCtCustom(): void {
		this.ctCustomOpen = !this.ctCustomOpen;
		if (this.ctCustomOpen && (!this.ctCustomFrom || !this.ctCustomTo)) {
			const to = new Date();
			const from = new Date();
			from.setDate(to.getDate() - (this.ctDays || 7));
			this.ctCustomFrom = from;
			this.ctCustomTo = to;
		}
	}
	applyCtCustomRange(): void {
		if (!this.ctCustomFrom || !this.ctCustomTo) { return; }
		if (this.ctCustomFrom > this.ctCustomTo) {
			const swap = this.ctCustomFrom;
			this.ctCustomFrom = this.ctCustomTo;
			this.ctCustomTo = swap;
		}
		this.ctCustom = true;
		this.ctShowRangePicker = false;
		this.loadCustomerTypeCustomRange();
	}
	refreshCustomerType(): void {
		if (this.ctCustom) { this.loadCustomerTypeCustomRange(); return; }
		this.categoryPieLoading = true;
		this.dashboardService.getCatAndLines(this.ctDays).pipe(takeUntil(this.destroy$)).subscribe({
			next: (results: any) => {
				this.customerTypeSales = results?.customer_type_sales || [];
				this.days = results?.days ?? this.ctDays;
				this.renderCustomerTypeChart();
			},
			error: () => { this.categoryPieLoading = false; }
		});
	}
	/** Custom ranges come from reports/customertypesales -- getcatandlines only takes a day count. */
	private loadCustomerTypeCustomRange(): void {
		if (!this.ctCustomFrom || !this.ctCustomTo) { return; }
		this.categoryPieLoading = true;
		this.reportsService.getCustomerTypeSales({
			datefrom: this.ctLocalIso(this.ctCustomFrom),
			dateto: this.ctLocalIso(this.ctCustomTo),
		}).pipe(takeUntil(this.destroy$)).subscribe({
			next: (rep: any) => {
				this.customerTypeSales = rep?.rows || [];
				this.renderCustomerTypeChart();
			},
			error: () => { this.categoryPieLoading = false; }
		});
	}
	/** Local Y-m-d -- toISOString() would shift the day for anyone behind UTC. */
	private ctLocalIso(d: Date): string {
		const pad = (n: number) => (n < 10 ? '0' : '') + n;
		return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
	}
	private get ctRangeSlug(): string {
		return this.ctCustom && this.ctCustomFrom && this.ctCustomTo
			? `${this.ctLocalIso(this.ctCustomFrom)}_${this.ctLocalIso(this.ctCustomTo)}`
			: `Last${this.days}d`;
	}
	private buildCtExportHtml(): string {
		const rows = this.customerTypeSlices.map(s => `<tr>
			<td>${this.ctDisplayLabel(s.label)}</td>
			<td style="text-align:right">${s.qty.toLocaleString()}</td>
			<td style="text-align:right">$${s.value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
			<td style="text-align:right">${(s.pct * 100).toFixed(1)}%</td>
		</tr>`).join('');
		return `<table>
			<thead><tr>
				<th>Customer Type</th>
				<th style="text-align:right">Units</th>
				<th style="text-align:right">Total Net</th>
				<th style="text-align:right">Share</th>
			</tr></thead>
			<tbody>${rows}</tbody>
		</table>`;
	}
	exportCustomerTypeXls(): void {
		this.exportXls({ html: this.buildCtExportHtml(), name: `CustomerTypeSales_${this.ctRangeSlug}_` });
	}
	exportCustomerTypePdf(): void {
		this.exportPdf({ html: this.buildCtExportHtml(), name: `CustomerTypeSales_${this.ctRangeSlug}_` });
	}
	readonly CT_DONUT_RADIUS = 40;
	readonly CT_DONUT_CIRC   = 2 * Math.PI * 40;
	private static readonly CT_THEME_PALETTE: Record<string, { light: [number, number, number]; base: [number, number, number]; dark: [number, number, number] }> = {
		purple:  { light: [206, 147, 216], base: [156,  39, 176], dark: [ 74,  20, 140] },
		primary: { light: [206, 147, 216], base: [156,  39, 176], dark: [ 74,  20, 140] },
		blue:    { light: [144, 202, 249], base: [ 33, 150, 243], dark: [ 25, 118, 210] },
		info:    { light: [128, 222, 234], base: [  0, 188, 212], dark: [  0,  96, 100] },
		green:   { light: [165, 214, 167], base: [ 76, 175,  80], dark: [ 27,  94,  32] },
		success: { light: [165, 214, 167], base: [ 76, 175,  80], dark: [ 27,  94,  32] },
		orange:  { light: [255, 204, 128], base: [255, 152,   0], dark: [230,  81,   0] },
		warning: { light: [255, 224, 130], base: [255, 193,   7], dark: [255, 143,   0] },
		red:     { light: [239, 154, 154], base: [244,  67,  54], dark: [183,  28,  28] },
		danger:  { light: [239, 154, 154], base: [244,  67,  54], dark: [183,  28,  28] },
		rose:    { light: [244, 143, 177], base: [233,  30,  99], dark: [136,  14,  79] },
	};
	private _ctThemeVarsCache: { [key: string]: string } | null = null;
	get ctThemeVars(): { [key: string]: string } {
		if (!this._ctThemeVarsCache) {
			const p = DashboardComponent.CT_THEME_PALETTE['warning'];
			const rgb  = (c: number[]) => `rgb(${c[0]},${c[1]},${c[2]})`;
			const rgba = (c: number[], a: number) => `rgba(${c[0]},${c[1]},${c[2]},${a})`;
			this._ctThemeVarsCache = {
				'--ct-accent':        rgb(p.base),
				'--ct-accent-dark':   rgb(p.dark),
				'--ct-accent-light':  rgb(p.light),
				'--ct-accent-tint':   rgba(p.base, 0.08),
				'--ct-accent-tint-2': rgba(p.base, 0.14),
			};
		}
		return this._ctThemeVarsCache;
	}
	/** Accent + icon for the flip-back detail panel, keyed by the widget being viewed. */
	private static readonly FLIP_BACK_STYLES: Record<string, { accent: string; icon: string }> = {
		'Open Orders':        { accent: 'danger',  icon: 'info_outline' },
		'Needs Bin':          { accent: 'warning', icon: 'store' },
		'Negative Inventory': { accent: 'success', icon: 'content_copy' },
		'New Items':          { accent: 'info',    icon: 'fiber_new' },
		'Open Quotes':        { accent: 'primary', icon: 'request_quote' },
		'Gap Report':         { accent: 'primary', icon: 'view_quilt' },
		'Metal Prices':       { accent: 'warning', icon: 'paid' },
		'Salesman Territory': { accent: 'info',    icon: 'groups' },
	};
	get flipBackThemeVars(): Record<string, string> {
		const style = DashboardComponent.FLIP_BACK_STYLES[this.viewing];
		return buildDashboardThemeVars('fb', style?.accent || 'primary');
	}
	get flipBackIcon(): string {
		return DashboardComponent.FLIP_BACK_STYLES[this.viewing]?.icon || 'dashboard';
	}
	get itemsSoldThemeVars(): Record<string, string> {
		return buildDashboardThemeVars('dcc', 'success');
	}
	get itemsReceivedThemeVars(): Record<string, string> {
		return buildDashboardThemeVars('dcc', 'warning');
	}
	get customerTypeTotal(): number {
		return (this.customerTypeSales || []).reduce((s: number, r: any) => s + (parseFloat(r.value) || 0), 0);
	}
	get customerTypeUnits(): number {
		return (this.customerTypeSales || []).reduce((s: number, r: any) => s + (parseFloat(r.qty) || 0), 0);
	}
	ctDisplayLabel(label: string): string {
		const t = (label || '').trim();
		return t === '' || t.toUpperCase() === 'NA' ? 'Unspecified' : t;
	}
	onCtSliceHover(i: number | null): void { this.hoveredCustomerTypeSlice = i; }
	private buildCustomerTypeSlices(): void {
		const palette = DashboardComponent.CT_THEME_PALETTE['warning'];
		const sorted = ([...(this.customerTypeSales || [])])
			.map((r: any) => ({ ...r, value: parseFloat(r.value) || 0, qty: parseFloat(r.qty) || 0 }))
			.sort((a: any, b: any) => b.value - a.value);
		const total = sorted.reduce((s: number, r: any) => s + r.value, 0);
		const n = sorted.length;
		const lerp = (a: number, b: number, t: number) => Math.round(a + (b - a) * t);
		let cumulative = 0;
		this.customerTypeSlices = sorted.map((row: any, i: number) => {
			const pct = total > 0 ? row.value / total : 0;
			const t = n <= 1 ? 0.5 : i / (n - 1);
			const r = lerp(palette.light[0], palette.dark[0], t);
			const g = lerp(palette.light[1], palette.dark[1], t);
			const b = lerp(palette.light[2], palette.dark[2], t);
			const dashLength = pct * this.CT_DONUT_CIRC;
			const dashOffset = -cumulative * this.CT_DONUT_CIRC;
			cumulative += pct;
			return { label: row.label, value: row.value, qty: row.qty, pct, color: `rgb(${r},${g},${b})`, dashLength, dashOffset };
		});
	}
	catchart!: Chart;
	datepicked: any = false;
	public info = [];
	item: any = [];
	public ordersbyday: any = [];
	public max: any = [];
	public percentup: any = [];
	activeReport: any = 'Report 1';
	openorders: any = 'notready';
	openOrdersList: any[] = [];
	openOrdersFlipFilter: any = false;
	openOrdersBucket1: any[] = [];
	openOrdersBucket2: any[] = [];
	openOrdersBucket3: any[] = [];
	needlocation: any = 'notready';

	// Cached: this getter runs on every change-detection pass — returning a
	// fresh array each time forces the stat card to re-render its chips.
	private _ageBucketsCache: { key: string; value: any[] } = { key: '', value: [] };
	get openOrdersAgeBuckets() {
		const key = this.openOrdersList.length
			? `${this.openOrdersBucket1.length}:${this.openOrdersBucket2.length}:${this.openOrdersBucket3.length}`
			: '';
		if (!key) {
			if (this._ageBucketsCache.key !== '') {
				this._ageBucketsCache = { key: '', value: [] };
			}
			return this._ageBucketsCache.value;
		}
		if (this._ageBucketsCache.key !== key) {
			this._ageBucketsCache = {
				key,
				value: [
					{ label: '3-5 Days', count: this.openOrdersBucket1.length, data: this.openOrdersBucket1 },
					{ label: '5-7 Days', count: this.openOrdersBucket2.length, data: this.openOrdersBucket2 },
					{ label: '> 7 Days', count: this.openOrdersBucket3.length, data: this.openOrdersBucket3 },
				],
			};
		}
		return this._ageBucketsCache.value;
	}

	get needlocationCount(): number | null {
		if (this.needlocation === 'notready') {
			return null;
		}
		return Array.isArray(this.needlocation) ? this.needlocation.length : 0;
	}

	get newitemsCount(): number | null {
		if (this.newitems === 'notready') {
			return null;
		}
		return this.newitems?.items?.length ?? 0;
	}
	negativestock: any = 'notready';
	newMessage: string;
	messageList: string[] = [];
	negativelink: any;
	needloclink: any;
	sender: any = [];
	flip = 'inactive';
	viewing: any = '';
	flip_text = '';
	color = 'blue'
	SENDER: any = [];
	messages = [];
	message: any = [];
	CHAT_ROOM = 'DashBoard';
	messageForm: any = [];
	carddate: any = [];
	posbyday: any = [];
	orderpweek: any = [];
	orderweek: any = [];
	config: any = false;
	popweek: any = [];
	poweek: any = [];
	popercentup: any = [];
	taxorders: any = [];
	thisoverlast: any = false;
	yearCount = 3;
	telegram_reports: string[] = ['Report 1', 'Report 2', 'Report 3', 'Report 4', 'Report 5'];
	datasource: any = false;

	linechart: any = false;
	customerTypeChart: any = false;
	public dataDailySalesChart: any = {
		labels: [],
		series: [],
	};

	catandlines: any = false;
	userData;
	hidedash: any = true;
	user: any;
	telegramAllowed = true;
	brandAllowed = true;
	metalPricesAllowed = false;

	/** Static (non-configurable) dashboards show the Sales Calendar drill only when the
	 *  client's widget registry lists 'day-sales' (e.g. AA) — keeps it off clients that don't want it. */
	get staticSalesCalendarAllowed(): boolean {
		const widgets = this.config?.dashboard?.widgets;
		return Array.isArray(widgets) && widgets.some((w: any) => w?.key === 'day-sales');
	}
	category_table_data: any = [];
	line_table_data: any = [];
	openquotes: any = 'notready';
	isPosUser = false;
	categoryPie = true;
	linePie = true;
	customerTypePie: any = true;
	customerTypePieLoading: boolean;
	linePieLoading: boolean;
	categoryPieLoading: boolean;
	// quoteCount: any = false;
	days: any = 7;
	orderSubject: any = new BehaviorSubject < any > (null);
	orderWatcher$: any = this.orderSubject.asObservable();

	labelData:any = false;
	showLabelData:any = false;
	labelViewing: any = false;
	labelLoading: any = false;

	labeltype: any = false;
	prefix: any = false;
	newitems: any = 'notready';

	/** Top 100 items dashboard card expanded (flip active) — parent uses col-12 vs col-6 */
	salesmanTopItemsFlipOpen = false;
	/** Top 100 customers dashboard card expanded */
	salesmanTopCustomersFlipOpen = false;

	// ─── Configurable widget layout (KM and any future client with dashboard.configurable) ───
	/** Visibility map — populated synchronously from config defaults, then overridden by saved prefs */
	widgetVisibility: { [key: string]: boolean } = {};
	/** Emits once when the saved widget layout has finished loading (or immediately
	 *  if the dashboard isn't configurable). Used to gate API calls so we don't
	 *  fetch data for widgets the user has hidden. */
	private widgetLayoutReady$ = new ReplaySubject<void>(1);
	/** Seeded once, when real config first resolves — guards against re-seeding (which would
	 *  wipe the user's layout) on later config re-emits. */
	private widgetLayoutInitialized = false;
	/** Returns true if the dashboard isn't configurable (no gating) or any of
	 *  the given widget keys are currently visible. */
	private anyWidgetVisible(keys: string[]): boolean {
		if (!this.config?.dashboard?.configurable) { return true; }
		return keys.some(k => this.isWidgetVisible(k));
	}
	/** Team leaderboard is for sales managers (group_level >= 3) and office/admin
	 *  (non-salesman) users. Clients that set dashboardSalesmanLeaderboardTop3
	 *  also show it to regular reps — the server caps their view to the Top 3. */
	get canViewLeaderboard(): boolean {
		const u = this.userData?.user;
		return !u?.issalesman || Number(u?.group_level) >= 3 || this.config?.dashboardSalesmanLeaderboardTop3 === true;
	}
	/** Ordered list of widget configs — drives *ngFor render order and col width on the page */
	widgetOrder: Array<{ key: string; width: number }> = [];
	showDashboardPicker = false;
	private _dashboardBaseJson: any = {};   // full stored JSON so we don't clobber other keys

	// ─── Grid builder state ───────────────────────────────────────────────────────
	/** Rows of visible widgets — built from widgetOrder when builder opens */
	builderRows: Array<Array<{ key: string; width: number }>> = [];
	/** Hidden widgets palette */
	builderPalette: Array<{ key: string; width: number }> = [];

	// Component state

	constructor(private printService: PrintService, private router: Router, private sanitizer: DomSanitizer, public dashboardService: DashboardService, public formBuilder: UntypedFormBuilder, private globalsService: GlobalsService, private globalSearchService: GlobalSearchService, private modalService: NgbModal, private usersService: UsersService, private ordersService: OrdersService, private reportsService: ReportsService, private cdr: ChangeDetectorRef) {
		this.color = this.globalsService.getColor();
		this.userData = this.usersService.getLocalUser();

		// Initialize component

		const configSub = this.globalSearchService.configsubscription.pipe(takeUntil(this.destroy$)).subscribe(r => {
			this.config = r;
			// Set metalPrices flag based on config
			this.metalPricesAllowed = this.config.metalPrices === true;
			switch (this.config.env.package) {
			case 'tires':
				this.telegramAllowed = false;
				break;
			case 'beauty':


				if (this.userData.user.issalesman) {

					if (this.userData.user.group_level >= 3) {
						this.telegramAllowed = true;
						this.linePie = true;
						this.categoryPie = true;
						this.customerTypePie = true;
						this.brandAllowed = true;
					}

					if (this.userData.user.group_level < 3) {
						this.telegramAllowed = false;
						this.linePie = false;
						this.categoryPie = true;
						this.customerTypePie = false;
						this.customerTypePie = false;
						// Reps (group_level < 3) get the brand-sales breakdown on their
						// dashboard too — it was manager-only (>= 3) before, which is why
						// AEs like Kaleigh Tremblay lost it. Manager-only widgets
						// (telegram / line & customer-type pies) stay gated above.
						this.brandAllowed = true;
					}

				}
				const posUserSub = this.usersService.isPosUser().pipe(takeUntil(this.destroy$)).subscribe((isPOS) => {
					if (isPOS) {
						this.isPosUser = true;
						this.telegramAllowed = false;
					}
				});
				this.subscriptions.push(posUserSub);
				break;
			}

			// Seed the configurable dashboard the moment real config is available.
			// config is a BehaviorSubject(null): on a hard reload of the dashboard route
			// it can resolve AFTER ngOnInit, so seeding here (not in ngOnInit) guarantees
			// widgetOrder is populated and the grid falls back to the configured widget
			// set instead of rendering blank until the user configures it by hand.
			if (r && !this.widgetLayoutInitialized) {
				this.widgetLayoutInitialized = true;
				this.initWidgetLayout();
			}

			// Use async loading instead of blocking loadData()
			this.loadDataAsync();
		});
		this.subscriptions.push(configSub);
	}

	updateOrderSubject(newValue: any) {
		this.orderSubject.next(newValue);
	}

	ngOnInit() {
		this.globalSearchService.mesagesallowed.next(false);
		this.messageForm = this.formBuilder.group({
			message: '',
		});

		// Removed auto-flip to Open Orders to keep dashboard visible on login
		// Users can manually click to view Open Orders if needed

		// Safety net: if config resolved in the constructor the subscription already
		// seeded the layout; if it hasn't resolved yet the subscription will seed it
		// when it arrives. This only covers the case config is present but unseeded.
		if (this.config && !this.widgetLayoutInitialized) {
			this.widgetLayoutInitialized = true;
			this.initWidgetLayout();
		}
	}

	/** Seed widgetOrder/visibility from config defaults (all visible), then override
	 *  asynchronously with the user's saved layout. For non-configurable dashboards
	 *  there's nothing to gate, so fire all fetches immediately. */
	private initWidgetLayout(): void {
		if (this.config?.dashboard?.configurable) {
			let widgets: any[] = this.config.dashboard.widgets || [];
			if (!this.canViewLeaderboard) {
				widgets = widgets.filter((w: any) => w.key !== 'salesman-territory');
			}
			this.widgetOrder = widgets.map((w: any) => ({ key: w.key, width: w.defaultWidth || 6 }));
			// Widgets flagged defaultVisible:false start in the picker palette instead of the grid
			widgets.forEach((w: any) => { this.widgetVisibility[w.key] = w.defaultVisible !== false; });
			this.loadWidgetLayout();   // async override — emits widgetLayoutReady$ when done
		} else {
			this.widgetLayoutReady$.next();
			this.widgetLayoutReady$.complete();
		}
	}

	// ─────────────────────────────────────────────────────────────────────────────
	// Configurable widget layout helpers
	// ─────────────────────────────────────────────────────────────────────────────

	private loadWidgetLayout(): void {
		const data = {
			userid: this.userData.user.userid,
			salesman: !!this.userData.user.salesman,
			pos: this.isPosUser,
		};
		this.usersService.getDashboard(data).subscribe({
			next: (res: any) => {
				let base: any = {};
				if (res?.success && res.dashboard) {
					try { base = JSON.parse(res.dashboard); } catch (_) { /* corrupt — start fresh */ }
				}
				this._dashboardBaseJson = base;

				const saved = base['__main_layout__'];
				if (saved) {
					// Merge visibility (new widgets default to visible)
					if (saved.visibility) {
						this.widgetVisibility = { ...this.widgetVisibility, ...saved.visibility };
					}
					// Load order with widths — handle both old format (string[]) and new ({key,width}[])
					if (saved.order?.length) {
						const normalize = (item: any): { key: string; width: number } =>
							typeof item === 'string'
								? { key: item, width: this._defaultWidth(item) }
								: { key: item.key, width: item.width ?? this._defaultWidth(item.key) };

						const savedList = (saved.order as any[]).map(normalize);
						const savedKeys = new Set(savedList.map(w => w.key));
						// Append any newly-added widgets (from config) that weren't in the saved list
						const extras = this.widgetOrder.filter(w => !savedKeys.has(w.key));
						// New widgets default to hidden (palette) for users with existing saved
						// layouts — except the salesman KPI/stats cards, which were previously
						// rendered outside the grid and must stay visible so reps don't lose them.
						const keepVisible = new Set(['salesman-kpis', 'salesman-stats']);
						// Anyone who can view the leaderboard but doesn't have it in their saved
						// layout yet (reps newly gaining Top-3 access, or non-salesman users whose
						// layout predates the widget) should keep it visible by default.
						if (this.canViewLeaderboard) {
							keepVisible.add('salesman-territory');
						}
						extras.forEach(w => { this.widgetVisibility[w.key] = keepVisible.has(w.key); });
						this.widgetOrder = [...savedList, ...extras];
					}
				}
				// Regular reps never get the team leaderboard, even from a saved layout.
				if (!this.canViewLeaderboard) {
					this.widgetOrder = this.widgetOrder.filter(w => w.key !== 'salesman-territory');
				}
				this.widgetLayoutReady$.next();
				this.widgetLayoutReady$.complete();
			},
			error: () => {
				// On failure, unblock fetches with default (all-visible) layout.
				this.widgetLayoutReady$.next();
				this.widgetLayoutReady$.complete();
			}
		});
	}

	private _defaultWidth(key: string): number {
		const found = (this.config?.dashboard?.widgets || []).find((w: any) => w.key === key);
		return found?.defaultWidth ?? 6;
	}

	/** Returns true when the widget should be shown.
	 *  For non-configurable clients widgetVisibility is {} so every key is undefined → true. */
	isWidgetVisible(key: string): boolean {
		return this.widgetVisibility[key] !== false;
	}

	/** Key of the widget currently showing its detail table, or null. */
	expandedWidgetKey: string | null = null;

	/** A widget that opens a wide detail table takes the full row while it is open,
	 *  then drops back to its configured width. The fixed-layout dashboard already
	 *  did this; the configurable grid rendered 'col-md-' + widget.width flat, so a
	 *  6-wide table widget stayed half width with its table squeezed inside it.
	 *  Keyed on widget.key from the template — not on the emitted title, which the
	 *  widgets decorate with their date range. */
	widgetColWidth(widget: { key: string; width: number }): number {
		return this.expandedWidgetKey === widget.key ? 12 : widget.width;
	}

	/** Track which widget is expanded, then hand off to the existing handler. */
	onWidgetView(event: any, key: string): void {
		this.expandedWidgetKey = event ? key : null;
		this.toggleFlipTest(event);
	}

	// ─── Grid builder ─────────────────────────────────────────────────────────

	/** Open/close the builder; rebuild grid state on open */
	toggleDashboardPicker(): void {
		this.showDashboardPicker = !this.showDashboardPicker;
		if (this.showDashboardPicker) { this.buildBuilderState(); }
	}

	/** Snapshot widgetOrder into rows + palette for the visual builder */
	buildBuilderState(): void {
		const rows: Array<Array<{ key: string; width: number }>> = [];
		let currentRow: Array<{ key: string; width: number }> = [];
		let rowWidth = 0;

		for (const w of this.widgetOrder) {
			if (!this.isWidgetVisible(w.key)) { continue; }
			const wCopy = { ...w };
			if (rowWidth + wCopy.width > 12 && currentRow.length) {
				rows.push(currentRow);
				currentRow = [];
				rowWidth = 0;
			}
			currentRow.push(wCopy);
			rowWidth += wCopy.width;
		}
		if (currentRow.length) { rows.push(currentRow); }
		if (!rows.length) { rows.push([]); }

		this.builderRows = rows;
		this.builderPalette = this.widgetOrder
			.filter(w => !this.isWidgetVisible(w.key))
			.map(w => ({ ...w }));
	}

	/** Dummy buffer for the new-row drop zone — always empty; onDropToNewRow drains it. */
	newRowBuffer: Array<{ key: string; width: number }> = [];

	/** All CDK list IDs for cdkDropListConnectedTo */
	get allBuilderListIds(): string[] {
		return ['db-palette', 'db-new-row', ...this.builderRows.map((_, i) => 'db-row-' + i)];
	}

	/** Drop onto the "Add Row" zone — creates a new row with the dragged widget in it. */
	onDropToNewRow(event: CdkDragDrop<Array<{ key: string; width: number }>>): void {
		const widget = event.item.data as { key: string; width: number };
		if (!widget) { return; }

		// Remove from source array
		const srcArray = event.previousContainer.data;
		const srcIndex = srcArray.findIndex(w => w.key === widget.key);
		if (srcIndex !== -1) { srcArray.splice(srcIndex, 1); }

		// Push into a brand-new row
		this.builderRows.push([{ ...widget }]);

		// Keep newRowBuffer empty
		this.newRowBuffer = [];

		this.syncFromBuilder();
	}

	/** CDK drop handler — handles within-row reorder, row-to-row, and palette ↔ row */
	onBuilderDrop(event: CdkDragDrop<Array<{ key: string; width: number }>>): void {
		const srcArray = event.previousContainer.data;
		const dstArray = event.container.data;

		if (event.previousContainer === event.container) {
			// Reorder within same list — CDK index is reliable here
			moveItemInArray(dstArray, event.previousIndex, event.currentIndex);
		} else {
			// Cross-list transfer: use the dragged item's key to find the real
			// source index instead of trusting CDK's DOM-derived previousIndex,
			// which can be wrong for horizontal lists with variable-width items.
			const draggedItem = event.item.data as { key: string; width: number };
			const actualSrcIndex = draggedItem
				? srcArray.findIndex(w => w.key === draggedItem.key)
				: event.previousIndex;
			const fromIndex = actualSrcIndex !== -1 ? actualSrcIndex : event.previousIndex;
			transferArrayItem(srcArray, dstArray, fromIndex, event.currentIndex);
		}
		this.syncFromBuilder();
	}

	trackByWidgetKey(_: number, w: { key: string; width: number }): string {
		return w.key;
	}

	trackByRowIndex(i: number, _: any): number {
		return i;
	}

	/** Change a widget's width inside the builder and sync */
	setBuilderWidgetWidth(rowIndex: number, widgetIndex: number, width: number): void {
		this.builderRows[rowIndex][widgetIndex] = { ...this.builderRows[rowIndex][widgetIndex], width };
		this.syncFromBuilder();
	}

	addBuilderRow(): void {
		this.builderRows.push([]);
	}

	removeBuilderRow(rowIndex: number): void {
		const removed = this.builderRows.splice(rowIndex, 1)[0] || [];
		this.builderPalette.push(...removed);
		this.syncFromBuilder();
	}

	/** Swap a row with its neighbor — the only way to reorder full-width (solo) rows,
	 *  since dragging a lone 12-width widget into another row just crowds the row. */
	moveBuilderRow(rowIndex: number, direction: -1 | 1): void {
		const target = rowIndex + direction;
		if (target < 0 || target >= this.builderRows.length) { return; }
		const [row] = this.builderRows.splice(rowIndex, 1);
		this.builderRows.splice(target, 0, row);
		this.syncFromBuilder();
	}

	removeWidgetFromRow(rowIndex: number, widgetIndex: number): void {
		const [widget] = this.builderRows[rowIndex].splice(widgetIndex, 1);
		if (widget) { this.builderPalette.push(widget); }
		this.syncFromBuilder();
	}

	rowTotalWidth(row: Array<{ key: string; width: number }>): number {
		return row.reduce((sum, w) => sum + w.width, 0);
	}

	/** Rebuild widgetOrder + visibility from builder state, then save */
	syncFromBuilder(): void {
		// Drop empty rows; always keep at least one so there's a drop target
		this.builderRows = this.builderRows.filter(r => r.length > 0);
		if (!this.builderRows.length) { this.builderRows.push([]); }

		const visible = ([] as Array<{ key: string; width: number }>).concat(...this.builderRows);
		const visibleKeys = new Set(visible.map(w => w.key));

		// update visibility map
		for (const key of Object.keys(this.widgetVisibility)) {
			this.widgetVisibility[key] = visibleKeys.has(key);
		}
		this.builderPalette.forEach(w => { this.widgetVisibility[w.key] = false; });

		// Rebuild widgetOrder: visible (in grid order) then hidden (palette)
		this.widgetOrder = [...visible, ...this.builderPalette];
		this.saveWidgetLayout();
	}

	toggleWidget(key: string): void {
		this.widgetVisibility = { ...this.widgetVisibility, [key]: !this.isWidgetVisible(key) };
		this.saveWidgetLayout();
	}

	moveWidget(index: number, direction: number): void {
		const newIndex = index + direction;
		if (newIndex < 0 || newIndex >= this.widgetOrder.length) { return; }
		moveItemInArray(this.widgetOrder, index, newIndex);
		this.saveWidgetLayout();
	}

	onWidgetDrop(event: CdkDragDrop<any[]>): void {
		if (event.previousIndex === event.currentIndex) { return; }
		moveItemInArray(this.widgetOrder, event.previousIndex, event.currentIndex);
		this.saveWidgetLayout();
	}

	setWidgetWidth(key: string, width: number): void {
		this.widgetOrder = this.widgetOrder.map(w => w.key === key ? { ...w, width } : w);
		if (this.showDashboardPicker) { this.buildBuilderState(); }
		this.saveWidgetLayout();
	}

	getWidgetLabel(key: string): string {
		const found = (this.config?.dashboard?.widgets || []).find((w: any) => w.key === key);
		return found ? found.label : key;
	}

	getWidgetIcon(key: string): string {
		const icons: { [k: string]: string } = {
			'open-orders':          'shopping_cart',
			'needs-bin':            'store',
			'negative-items':       'content_copy',
			'new-items':            'fiber_new',
			'open-quotes':          'request_quote',
			'gap-report':           'view_quilt',
			'new-customers':        'person_add',
			'no-purchase':          'remove_shopping_cart',
			'open-credits':         'account_balance_wallet',
			'open-purchase-orders': 'local_shipping',
			'canceled-orders':      'cancel',
			'trending-products':    'trending_up',
			'top-customers':        'emoji_events',
			'brand-report':         'storefront',
			'line-pie':             'pie_chart',
			'category-pie':         'donut_small',
			'customer-type-pie':    'group',
			'sales-table':          'table_chart',
			'day-sales':            'event',
			'salesman-territory':   'groups',
			'salesman-kpis':        'insights',
			'salesman-stats':       'map',
		};
		return icons[key] || 'widgets';
	}

	getWidgetColorClass(key: string): string {
		const colors: { [k: string]: string } = {
			'open-orders':          'danger',
			'needs-bin':            'warning',
			'negative-items':       'success',
			'new-items':            'info',
			'open-quotes':          'primary',
			'gap-report':           'primary',
			'new-customers':        'info',
			'no-purchase':          'rose',
			'open-credits':         'success',
			'open-purchase-orders': 'info',
			'canceled-orders':      'danger',
			'trending-products':    'success',
			'top-customers':        'warning',
			'brand-report':         'primary',
			'line-pie':             'danger',
			'category-pie':         'info',
			'customer-type-pie':    'warning',
			'sales-table':          'success',
			'day-sales':            'primary',
			'salesman-territory':   'info',
			'salesman-kpis':        'info',
			'salesman-stats':       'info',
		};
		return colors[key] || 'primary';
	}

	/** Wipe saved layout and rebuild everything from config defaults */
	resetDashboardToDefaults(): void {
		const widgets: any[] = this.config?.dashboard?.widgets || [];
		this.widgetOrder = widgets.map((w: any) => ({ key: w.key, width: w.defaultWidth || 6 }));
		this.widgetVisibility = {};
		widgets.forEach((w: any) => { this.widgetVisibility[w.key] = w.defaultVisible !== false; });
		const payload = { ...this._dashboardBaseJson, '__main_layout__': null };
		this.usersService.saveDashboard({ userid: this.userData.user.userid, dashboard: JSON.stringify(payload) }).subscribe();
		if (this.showDashboardPicker) { this.buildBuilderState(); }
	}

	private saveWidgetLayout(): void {
		const layout = { visibility: this.widgetVisibility, order: this.widgetOrder };
		const payload = { ...this._dashboardBaseJson, '__main_layout__': layout };
		const data = {
			userid: this.userData.user.userid,
			dashboard: JSON.stringify(payload),
		};
		this.usersService.saveDashboard(data).subscribe((res: any) => {
			if (res?.success) {
				this._dashboardBaseJson = payload;
			}
		});
	}

	viewHistory(month: any, year: any) {
		if (parseInt(month) < 10) {
			month = '0' + month;
		}

		const date = new Date(year + '-' + month + '-15')

		this.datepicked = date;

		this.modalService.open(this.monthViewRef, { ariaLabelledBy: 'modal-title', size: 'xl', animation: false }).result.then((result) => {

		}, (reason) => {

		});

	}

	invoiceOrder(event: any) {
		this.router.navigate(['orders/invoice/' + event + '/dispatch']);
	}

	selectItemLookup(event: any) {

		if (this.isPosUser) {
			this.globalSearchService.setPreOrder(event);
			this.router.navigate(['./counter-pos/' + event.header.debtorno + '/' + event.header.branchcode]);
		} else {
			this.router.navigate(['./orders/entry/' + event.header.debtorno + '/' + event.header.branchcode]);
		}
	}

	getMonthYearQty(month: any, year: any) {

		const obj = year.qty.filter((monthyear: any) => {
			return monthyear.label == month;
		})[0];

		switch (obj.monthgrowth) {
		case -1:
			var color = '';
			break;
		default:
			var color = (obj.monthgrowth > 0) ? 'text-success' : 'text-danger'
			break;
		}

		switch (obj.monthpreviousgrowth) {
		case 0:
		case -1:
			var mcolor = '';
			break;
		default:
			var mcolor = (obj.monthpreviousgrowth > 0) ? 'text-success' : 'text-danger'
			break;
		}

		const returnValue = {
			percent_month: obj.monthpreviousgrowth,
			percent_month_color: mcolor,
			percent_month_icon: (obj.monthpreviousgrowth > 0) ? 'fa-long-arrow-up' : 'fa-long-arrow-down',
			percent: (obj.monthgrowth == -1) ? 0 : obj.monthgrowth,
			class: color,
			icon: (obj.monthgrowth > 0) ? 'fa-long-arrow-up' : 'fa-long-arrow-down',
		};

		return returnValue;
	}

	formatData(data: any[] = [], title: string, expanded = false): any {
		const _labels: string[] = [];
		const _series: number[] = [];
		const _colors: string[] = [];

		// Richer color palette (30+ unique colors)
		const colorPalette: string[] = [
			'#4e79a7', '#f28e2b', '#e15759', '#76b7b2', '#59a14f',
			'#edc949', '#af7aa1', '#ff9da7', '#9c755f', '#bab0ab',
			'#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd',
			'#8c564b', '#e377c2', '#7f7f7f', '#bcbd22', '#17becf',
			'#a05d56', '#6b486b', '#d0743c', '#ff8c00', '#98abc5',
			'#8a89a6', '#7b6888', '#6b486b', '#a05d56', '#d0743c'
		];

		if (!Array.isArray(data)) {data = [];}

		// Limit to top 10 by value unless expanded
		if (!expanded) {
			data = [...data]
				.sort((a, b) => (b.value ?? 0) - (a.value ?? 0))
				.slice(0, 10);
		}

		data.forEach((item, index) => {
			const label = item.label || '**UNKNOWN**';
			const value = this.config.env.package === 'tires' ? Number(item.qty || 0) : Number(item.value || 0);

			const color = colorPalette[index % colorPalette.length];

			_labels.push(label);
			_series.push(value);
			_colors.push(color);

			// Attach reference metadata for optional external legend use
			item.className = `bar-color-${index}`;
			item.color = color;
			item.displayValue = `$${value.toLocaleString()}`;
			item.tooltip = `${label}: $${value.toLocaleString()}`;
		});

		return {
			labels: _labels,
			datasets: [{
				fill: false,
				label: title,
				data: _series,
				backgroundColor: _colors,
				borderColor: _colors,
				borderWidth: 1,
				hoverOffset: 10,
			}]
		};
	}

	getCostTotalYear(year: any) {
		const value = year.cost.reduce(function(accumulator: number, items: any) {
			const addon = parseFloat(items.value);
			return accumulator + addon;
		}, 0);

		return value;
	}

	yearQtyGrowth(yearin: any) {

		// 		let value  = year.qty.reduce(function(accumulator: number, items: any) {
		// 			let addon = parseFloat(items.value);
		// 			return accumulator + addon;
		// 		}, 0);
		//
		// 		return value;
	}

	getSaleTotalYear(year: any) {
		let value = 0
		if (year) {
			value = year.sales.reduce(function(accumulator: number, items: any) {
				const addon = parseFloat(items.value);
				return accumulator + addon;
			}, 0);
		} else {
			value = 0
		}

		return value;
	}

	getQtyTotalYear(year: any) {
		const value = year.qty.reduce(function(accumulator: number, items: any) {
			const addon = parseFloat(items.value);
			return accumulator + addon;
		}, 0);

		return value;
	}

	quoteCount(e) {

	}

	subscritionsactive: any = [];
	overLastStatus: { loading: boolean;day: number;monthname: string;monthnum: number;fromyear: string;toyear: string;viewing: string;source: number;message: string;temp: { year: any;month: any; }; };
	lineover: any = false;
	categorySales: any = [];

	// Memory leak prevention
	private destroy$ = new Subject<void>();
	private subscriptions: any[] = [];
	private timeouts: any[] = [];
	loadData() {

		const openQuotesSub = this.ordersService.getOpenQuotes().pipe(takeUntil(this.destroy$)).subscribe(async (results: any) => {
			this.openquotes = results.length;
		});
		this.subscriptions.push(openQuotesSub);


		this.subscritionsactive.openorder = this.dashboardService.getOpenCOunt().pipe(takeUntil(this.destroy$)).subscribe(async (results: any) => {
			this.openorders = results.data;
			this.updateOrderSubject(results.data);
			if (results.orders) {
				this.openOrdersList = results.orders;
				this.openOrdersFlipFilter = results.orders.map((o: any) => o.orderno);
				const buckets = this.dashboardService.computeOpenOrderAgeBuckets(results.orders);
				this.openOrdersBucket1 = buckets.bucket1;
				this.openOrdersBucket2 = buckets.bucket2;
				this.openOrdersBucket3 = buckets.bucket3;
			}
		});

		this.subscritionsactive.neg = this.dashboardService.getNegative().pipe(takeUntil(this.destroy$)).subscribe(async (results: any) => {
			this.negativestock = (results.data) ? results.data.length : 0;
		});

		this.subscritionsactive.needloc = this.dashboardService.getNeedLocation().pipe(takeUntil(this.destroy$)).subscribe(async (results: any) => {
			this.needlocation = results.data;
		});

		Chart.register(...registerables);
		Chart.register(ChartDataLabels);

		this.linePieLoading = true;
		this.categoryPieLoading = true;
		this.customerTypePieLoading = true
		this.subscritionsactive.catline = this.dashboardService.getCatAndLines().subscribe(async (results: any) => {
			this.catandlines = results;
			this.days = results.days;
			//double titles
			//const title = this.config.env.package == 'tires' ? 'Category Sales Last 7 Days' : 'Category Sales Last 7 Days';
			const title = '';

			this.categorySales = results.category_sales;
			if (this.catchart) {
				this.catchart.destroy();
			}
			if (this.categoryPie) {
				this.renderCategoryChart();
			}

			if (this.linechart) {
				this.linechart.destroy();
			}

			if (this.linePie && results.line_sales) {
				const linedata = this.formatData(results.line_sales, 'Product Line Sales', false);

				if(this.config.env.package === 'tires'){
					this.labeltype = 'Units';
					this.prefix = false;
				}else{
					this.labeltype = '$';
					this.prefix = true;
				}

				this.linechart = new Chart('plineChart', {
				type: 'bar',
				data: linedata,
				options: {
					indexAxis: 'y',
					responsive: true,
					maintainAspectRatio: false,
					plugins: {
						legend: { display: false },
						title: {
							display: false,
							text: 'Product Line Sales (Last 7 Days)',
							color: '#222',
							font: {
								size: 20,
								weight: 'bold',
								family: 'Segoe UI'
							},
							padding: { top: 10, bottom: 20 }
						},
						tooltip: {
							backgroundColor: '#333',
							titleColor: '#fff',
							bodyColor: '#eee',
							borderColor: '#999',
							borderWidth: 1,
							callbacks: {
								label: (context) => {
									if(this.prefix){
										return `${this.labeltype}${context.parsed.x.toLocaleString()}`;
									}else{
										return `${context.parsed.x.toLocaleString()} ${this.labeltype}`;
									}
								}
							}
						},
						datalabels: {
							color: '#000',
							anchor: (context) => {
								const value = Number(context.dataset.data[context.dataIndex]);
								const max = context.chart.scales.x.max || 1; // avoid division by 0
								const chartWidth = context.chart.chartArea.right - context.chart.chartArea.left;
								const pxValue = (value / max) * chartWidth;
								return pxValue > 80 ? 'center' : 'end';
							},
							align: (context) => {
								const value = Number(context.dataset.data[context.dataIndex]);
								const max = context.chart.scales.x.max || 1;
								const chartWidth = context.chart.chartArea.right - context.chart.chartArea.left;
								const pxValue = (value / max) * chartWidth;
								return pxValue > 80 ? 'center' : 'right';
							},
							formatter: (value) => {
								if(this.prefix){
									return `${this.labeltype}${value.toLocaleString()}`;
								}else{
									return `${value.toLocaleString()} ${this.labeltype}`;
								}
							},
							font: {
								size: 13,
								weight: 'bold'
							},
							clip: false
						}
					},
					scales: {
						x: {
							beginAtZero: true,
							ticks: {
								color: '#444',
								callback: (value) => {
									if(this.prefix){
										return `${this.labeltype}${value}`;
									}else{
										return `${value} ${this.labeltype}`;
									}
								}
							},
							grid: { color: '#eee' }
						},
						y: {
							ticks: {
								color: '#444',
								font: { size: 14 }
							},
							grid: { display: false }
						}
					},
					animation: {
						duration: 800,
						easing: 'easeOutQuart'
					}
				},
				plugins: [ChartDataLabels]
				});
			}

			this.linePieLoading = false;

			if (this.customerTypeChart) {
				this.customerTypeChart.destroy();
			}

			this.customerTypeSales = results.customer_type_sales;

			this.renderCustomerTypeChart();

		});

		this.negativelink = this.config.apiServer.baseUrl + 'reports/report/html/?report=samples/221123110123.sql';
		this.needloclink = this.config.apiServer.baseUrl + 'reports/report/html/?report=samples/221122023111.sql';
		if (this.config.env.package === 'tires') {
			const receivedSub = this.dashboardService.getReceievedTotalByDay().pipe(takeUntil(this.destroy$)).subscribe(async (results: DailySales) => {
				this.posbyday = results.data;
				this.poweek = results.week;
				this.popweek = results.pweek;
				this.popercentup = results.percentup;

				const labels = []
				const series = []
				this.posbyday.forEach((keys: any, vals: any) => {
					labels.push(keys.label)
					series.push(keys.count)
				});

				const datawebsiteViewsChart = {
					labels: labels,
					series: [
						series

					]
				};
				const optionswebsiteViewsChart = {
					lineSmooth: Chartist.Interpolation.cardinal({
						tension: 0
					}),
					axisX: {
						showGrid: false
					},
					//showArea: true,
					low: 0,
					high: results.max,
					chartPadding: { top: 0, right: 5, bottom: 0, left: 0 }
				};

				const websiteViewsChart = new Chartist.Line('#websiteViewsChart', datawebsiteViewsChart, optionswebsiteViewsChart);

				//start animation for the Emails Subscription Chart
				this.startAnimationForBarChart(websiteViewsChart);

			});
			this.subscriptions.push(receivedSub);
			const orderCountDaySub = this.dashboardService.getOrderCountByDay().pipe(takeUntil(this.destroy$)).subscribe(async (results: DailySales) => {

				this.ordersbyday = results.data;
				this.max = results.max;
				this.orderweek = results.week;
				this.orderpweek = results.pweek;

				this.percentup = results.percentup
				const dataDailySalesChart: any = {
					labels: ['M', 'T', 'W', 'T', 'F', 'S', 'S'],
					series: [
						[12, 17, 7, 17, 23, 18, 38]
					]
				};

				const labels = []
				const series = []
				this.ordersbyday.forEach((keys: any, vals: any) => {
					labels.push(keys.label)
					series.push(keys.count)
				});

				this.dataDailySalesChart.labels = labels;
				this.dataDailySalesChart.series = [series];

				const optionsDailySalesChart: any = {
					lineSmooth: Chartist.Interpolation.cardinal({
						tension: 0
					}),
					low: 0,
					high: this.max,
					chartPadding: { top: 0, right: 0, bottom: 0, left: 0 },
				}

				const dailySalesChart = new Chartist.Line('#dailySalesChart', this.dataDailySalesChart, optionsDailySalesChart);
				this.startAnimationForLineChart(dailySalesChart);

			});
			this.subscriptions.push(orderCountDaySub);
		}
	}

	loadDataAsync() {
		// Load all data asynchronously without blocking UI
		this.loadAllData();
	}

	loadAllData() {
		// Wait for the saved widget layout to load before firing gated fetches —
		// otherwise we'd hit the API for widgets the user has actually hidden.
		this.widgetLayoutReady$.pipe(takeUntil(this.destroy$)).subscribe(() => this._fireGatedFetches());

		// Ungated fetches (data feeds always-visible UI elements, not just configurable widgets).
		// Need-location feeds an always-visible counter outside the configurable grid.
		const needLocSub = this.dashboardService.getNeedLocation().pipe(takeUntil(this.destroy$)).subscribe({
			next: (results: any) => { this.needlocation = results.data; },
			error: () => { this.needlocation = []; }
		});
		this.subscriptions.push(needLocSub);

		// Tires-only daily charts are gated by package, not by widget.
		this.loadChartData();
	}

	/** Fetches that feed *only* configurable widgets — skipped entirely if the
	 *  widget is hidden. Called once `widgetLayoutReady$` has fired. */
	private _fireGatedFetches(): void {
		// open-orders widget
		if (this.anyWidgetVisible(['open-orders'])) {
			const openOrdersSub = this.dashboardService.getOpenCOunt().pipe(takeUntil(this.destroy$)).subscribe({
				next: (results: any) => {
					this.openorders = results.data;
					this.updateOrderSubject(results.data);
					if (results.orders) {
						this.openOrdersList = results.orders;
						this.openOrdersFlipFilter = results.orders.map((o: any) => o.orderno);
						const buckets = this.dashboardService.computeOpenOrderAgeBuckets(results.orders);
						this.openOrdersBucket1 = buckets.bucket1;
						this.openOrdersBucket2 = buckets.bucket2;
						this.openOrdersBucket3 = buckets.bucket3;
					}
				},
				error: () => { this.openorders = 0; }
			});
			this.subscriptions.push(openOrdersSub);
		}

		// open-quotes widget (also feeds the beauty salesman/POS stat card on non-configurable dashboards)
		if (this.anyWidgetVisible(['open-quotes'])) {
			const quotesSub = this.ordersService.getOpenQuotes().pipe(takeUntil(this.destroy$)).subscribe({
				next: (results: any) => { this.openquotes = results.length; },
				error: () => { this.openquotes = 0; }
			});
			this.subscriptions.push(quotesSub);
		}

		// new-items widget
		if (this.anyWidgetVisible(['new-items'])) {
			const newItemsSub = this.reportsService.getNitmsReport({}).pipe(takeUntil(this.destroy$)).subscribe({
				next: (results: any) => { this.newitems = results; },
				error: () => { this.newitems = []; }
			});
			this.subscriptions.push(newItemsSub);
		}

		// negative-items widget
		if (this.anyWidgetVisible(['negative-items'])) {
			const negativeSub = this.dashboardService.getNegative().pipe(takeUntil(this.destroy$)).subscribe({
				next: (results: any) => { this.negativestock = (results.data) ? results.data.length : 0; },
				error: () => { this.negativestock = 0; }
			});
			this.subscriptions.push(negativeSub);
		}

		// cat/line/customer-type widgets — share a single heavy endpoint.
		if (this.anyWidgetVisible(['line-pie', 'category-pie', 'customer-type-pie'])) {
			this.linePieLoading = true;
			this.categoryPieLoading = true;
			this.customerTypePieLoading = true;
			const catLinesSub = this.dashboardService.getCatAndLines(this.ctDays).pipe(takeUntil(this.destroy$)).subscribe({
				next: (results: any) => {
					this.catandlines = results;
					this.days = results.days;
					this.customerTypeSales = results.customer_type_sales || [];
					this.renderCategoryChart();
					this.renderCustomerTypeChart();
					this.renderLineChart();
				},
				error: () => {
					this.linePieLoading = false;
					this.categoryPieLoading = false;
					this.customerTypePieLoading = false;
				}
			});
			this.subscriptions.push(catLinesSub);
		}
	}

	/* eslint-disable */
	/** Legacy ungated loaders — left intact below but unreachable because the
	 *  refactored loadAllData above returns before this block. Kept for reference. */
	private _legacyLoadAllDataBody() {

		// Load quotes
		const quotesSub = this.ordersService.getOpenQuotes().pipe(takeUntil(this.destroy$)).subscribe({
			next: (results: any) => {
				this.openquotes = results.length;
			},
			error: (error) => {
				console.error('Failed to load open quotes:', error);
				this.openquotes = 0;
			}
		});
		this.subscriptions.push(quotesSub);

		// Load negative inventory
		const negativeSub = this.dashboardService.getNegative().pipe(takeUntil(this.destroy$)).subscribe({
			next: (results: any) => {
				this.negativestock = (results.data) ? results.data.length : 0;
			},
			error: (error) => {
				console.error('Failed to load negative inventory:', error);
				this.negativestock = 0;
			}
		});
		this.subscriptions.push(negativeSub);

		// Load need location data
		const needLocSub = this.dashboardService.getNeedLocation().pipe(takeUntil(this.destroy$)).subscribe({
			next: (results: any) => {
				this.needlocation = results.data;
			},
			error: (error) => {
				console.error('Failed to load need location data:', error);
				this.needlocation = [];
			}
		});
		this.subscriptions.push(needLocSub);

		// Load chart data in background
		this.loadChartData();
	}

	loadChartData() {
		// Initialize charts
		Chart.register(...registerables);
		Chart.register(ChartDataLabels);

		// NOTE: getCatAndLines() is now fired in _fireGatedFetches() (gated by
		// line-pie / category-pie / customer-type-pie visibility), so we skip
		// it here. Only the daily charts below remain.

		// Load daily sales data
		const orderCountSub = this.dashboardService.getOrderCountByDay().pipe(takeUntil(this.destroy$)).subscribe({
			next: (results: any) => {
				this.ordersbyday = results.data;
				this.max = results.max;
				this.orderweek = results.week;
				this.orderpweek = results.pweek;
				this.percentup = results.percentup;

				// Update chart data
				const labels = [];
				const series = [];
				this.ordersbyday.forEach((keys: any, vals: any) => {
					labels.push(keys.label);
					series.push(keys.count);
				});

				this.dataDailySalesChart = {
					labels: labels,
					series: [series]
				};
			},
			error: (error) => {
				console.error('Failed to load daily sales data:', error);
			}
		});
		this.subscriptions.push(orderCountSub);

		// Load POS data
		const receivedSub = this.dashboardService.getReceievedTotalByDay().pipe(takeUntil(this.destroy$)).subscribe({
			next: (results: any) => {
				this.posbyday = results.data;
				this.poweek = results.week;
				this.popweek = results.pweek;
				this.popercentup = results.percentup;
			},
			error: (error) => {
				console.error('Failed to load POS data:', error);
			}
		});
		this.subscriptions.push(receivedSub);
	}




	startAnimationForPie(chart) {

		chart.on('draw', function(data) {

			if (data.type === 'slice') {
				// Get the total path length in order to use for dash array animation
				const pathLength = data.element._node.getTotalLength();

				// Set a dasharray that matches the path length as prerequisite to animate dashoffset
				data.element.attr({
					'stroke-dasharray': pathLength + 'px ' + pathLength + 'px'
				});

				// Create animation definition while also assigning an ID to the animation for later sync usage
				const animationDefinition = {
					'stroke-dashoffset': {
						id: 'anim' + data.index,
						dur: 5000,
						from: -pathLength + 'px',
						to: '0px',
						easing: Chartist.Svg.Easing.easeOutQuint,
						// We need to use `fill: 'freeze'` otherwise our animation will fall back to initial (not visible)
						fill: 'freeze',
						begin: 'anim' + (data.length - 1)
					}
				};

				// If this was not the first slice, we need to time the animation so that it uses the end sync event of the previous animation
				if (data.index !== 0) {
					animationDefinition['stroke-dashoffset'].begin = 'anim' + (data.index - 1) + '.end';
				}

				// We need to set an initial value before the animation starts as we are not in guided mode which would do that for us
				data.element.attr({
					'stroke-dashoffset': -pathLength + 'px'
				});

				// We can't use guided mode as the animations need to rely on setting begin manually
				// See http://gionkunz.github.io/chartist-js/api-documentation.html#chartistsvg-function-animate
				data.element.animate(animationDefinition, false);
			}
		});
		chart.on('created', () => {
			const timeoutId = setTimeout(() => {
				if (chart && typeof chart.update === 'function') {
					chart.update();
				}
			}, 10000);
			this.timeouts.push(timeoutId);
		});
	}

	startAnimationForLineChart(chart) {
		let seq: any, delays: any, durations: any;
		seq = 0;
		delays = 80;
		durations = 500;

		chart.on('draw', function(data) {
			if (data.type === 'line' || data.type === 'area') {
				data.element.animate({
					d: {
						begin: 600,
						dur: 700,
						from: data.path.clone().scale(1, 0).translate(0, data.chartRect.height()).stringify(),
						to: data.path.clone().stringify(),
						easing: Chartist.Svg.Easing.easeOutQuint
					}
				});
			} else if (data.type === 'point') {
				seq++;
				data.element.animate({
					opacity: {
						begin: seq * delays,
						dur: durations,
						from: 0,
						to: 1,
						easing: 'ease'
					}
				});
			}
		});

		seq = 0;
	};

	startAnimationForBarChart(chart) {
		let seq2: any, delays2: any, durations2: any;

		seq2 = 0;
		delays2 = 80;
		durations2 = 500;
		chart.on('draw', function(data) {
			if (data.type === 'bar') {
				seq2++;
				data.element.animate({
					opacity: {
						begin: seq2 * delays2,
						dur: durations2,
						from: 0,
						to: 1,
						easing: 'ease'
					}
				});
			}
		});

		seq2 = 0;
	};

	randomString(length, chars) {
		let result = '';
		for (let i = length; i > 0; --i) { result += chars[Math.floor(Math.random() * chars.length)]; }
		return result;
	}

	onSalesmanTopItemsFlip(ev: any): void {
		this.salesmanTopItemsFlipOpen = !!ev;
	}

	onSalesmanTopCustomersFlip(ev: any): void {
		this.salesmanTopCustomersFlipOpen = !!ev;
	}

	/** col-6 when both widgets collapsed; col-12 when this one is expanded; hide sibling while other expanded */
	salesmanTopItemsWrapperColClass(): string {
		if (!this.config?.dashboardSalesmanTop100) {
			return 'col-12';
		}
		const paired = this.config.dashboardSalesmanTop100 && this.config.dashboardSalesmanTopCustomers;
		if (!paired) {
			return 'col-12';
		}
		if (this.salesmanTopCustomersFlipOpen) {
			return 'd-none';
		}
		if (this.salesmanTopItemsFlipOpen) {
			return 'col-12';
		}
		return 'col-lg-6 col-md-6 col-sm-12 mb-3 mb-md-0';
	}

	salesmanTopCustomersWrapperColClass(): string {
		if (!this.config?.dashboardSalesmanTopCustomers) {
			return 'col-12';
		}
		const paired = this.config.dashboardSalesmanTop100 && this.config.dashboardSalesmanTopCustomers;
		if (!paired) {
			return 'col-12';
		}
		if (this.salesmanTopItemsFlipOpen) {
			return 'd-none';
		}
		if (this.salesmanTopCustomersFlipOpen) {
			return 'col-12';
		}
		return 'col-lg-6 col-md-6 col-sm-12';
	}

	toggleFlip(viewing: any) {
		this.viewing = viewing
		this.flip = (this.flip == 'active') ? 'inactive' : 'active';
	}

	toggleFlipOpenOrdersBucket(bucket: any[]) {
		this.openOrdersFlipFilter = bucket.map((o: any) => o.orderno);
		this.toggleFlip('Open Orders');
	}

	toggleFlipTest(viewing: any) {
		switch(viewing?.comp) {
		case 'nopurch':
			this.viewing = viewing?.comp;
			break;
		case 'newcustomer':
			this.viewing = viewing?.comp;
			break;
		default:
			this.viewing = viewing
			break;
		}

		return this.viewing;
	}

	nextChar(c) {
		return String.fromCharCode(c.charCodeAt(0) + 1);
	}

	getDataChartPoint(value: any, label: any, letter: any) {
		return {
			value: value,
			//name: label,
			className: 'ct-series-' + letter,
		}
	}

	ngOnDestroy() {
		// Complete destroy$ subject to unsubscribe all takeUntil subscriptions
		this.destroy$.next();
		this.destroy$.complete();

		// Unsubscribe all stored subscriptions
		this.subscriptions.forEach(sub => {
			if (sub && typeof sub.unsubscribe === 'function') {
				sub.unsubscribe();
			}
		});
		this.subscriptions = [];

		// Unsubscribe legacy subscriptions
		if (this.subscritionsactive.openorder) {
			this.subscritionsactive.openorder.unsubscribe();
		}

		if (this.subscritionsactive.neg) {
			this.subscritionsactive.neg.unsubscribe();
		}

		if (this.subscritionsactive.thislast) {
			this.subscritionsactive.thislast.unsubscribe();
		}

		if (this.subscritionsactive.catline) {
			this.subscritionsactive.catline.unsubscribe();
		}

		if (this.subscritionsactive.needloc) {
			this.subscritionsactive.needloc.unsubscribe();
		}

		// Destroy all chart instances
		if (this.catchart && typeof this.catchart.destroy === 'function') {
			this.catchart.destroy();
		}

		if (this.linechart && typeof this.linechart.destroy === 'function') {
			this.linechart.destroy();
		}

		if (this.customerTypeChart && typeof this.customerTypeChart.destroy === 'function') {
			this.customerTypeChart.destroy();
		}

		// Clear all timeouts
		this.timeouts.forEach(timeoutId => {
			if (timeoutId) {
				clearTimeout(timeoutId);
			}
		});
		this.timeouts = [];

		// Complete BehaviorSubject
		if (this.orderSubject) {
			this.orderSubject.complete();
		}

		// Unsubscribe labelLoading if it's a subscription
		if (this.labelLoading && typeof this.labelLoading.unsubscribe === 'function') {
			this.labelLoading.unsubscribe();
		}
	}

	generateGradientColors(count: number) {
		const startColor = [255, 94, 98]; // Coral Red
		const endColor = [103, 58, 183]; // Deep Purple

		return Array.from({ length: count }, (_, i) => {
			const ratio = i / Math.max(count - 1, 1);
			const r = Math.round(startColor[0] + (endColor[0] - startColor[0]) * ratio);
			const g = Math.round(startColor[1] + (endColor[1] - startColor[1]) * ratio);
			const b = Math.round(startColor[2] + (endColor[2] - startColor[2]) * ratio);
			return `rgb(${r}, ${g}, ${b})`;
		});
	};

	renderCategoryChart() {
		if (this.catchart) {
			this.catchart.destroy(); // Prevent duplicate charts
		}

		this.cdr.detectChanges();

		const canvas = this.catChartRef?.nativeElement;
		if (!canvas) {
			// Canvas not in DOM — happens when the active layout doesn't include
			// the category-pie widget. Retry once after the next tick in case the
			// widget mounts (e.g. config arrives after the data subscription fires).
			setTimeout(() => {
				if (this.catChartRef?.nativeElement) { this.renderCategoryChart(); }
			}, 0);
			return;
		}
		const ctx = canvas.getContext('2d');
		if (!ctx) { return; }

		const gradient = this.generateGradientColors(this.categorySales.length);

		this.catchart = new Chart(ctx, {
			type: 'bar',
			data: {
				labels: this.categorySales.map(item => item.label),
				datasets: [{
					label: 'Total $',
					data: this.categorySales.map(item => item.value),
					backgroundColor: gradient,
					borderColor: gradient,
					borderWidth: 2,
					borderRadius: 8,
					hoverBackgroundColor: 'rgba(54, 162, 235, 1)',
					hoverBorderColor: 'rgba(75, 192, 192, 1)'
				}]
			},
			options: {
				responsive: true,
				maintainAspectRatio: false,
				indexAxis: 'x', // vertical bars
				animation: {
					duration: 1500,
					easing: 'easeOutBounce'
				},
				scales: {
					x: {
						grid: { color: 'rgba(200, 200, 200, 0.3)' },
						title: {
							display: true,
							text: 'Product Category',
							color: '#333',
							font: { size: 14, weight: 'bold' }
						},
						ticks: {
							color: '#444',
							font: { size: 12 }
							// ✅ Removed incorrect $ formatting
						}
					},
					y: {
						beginAtZero: true,
						grid: { display: false },
						title: {
							display: true,
							text: 'Total $',
							color: '#333',
							font: { size: 14, weight: 'bold' }
						},
						ticks: {
							color: '#444',
							font: { size: 12 },
							callback: (value: number | string) => {
								const val = typeof value === 'string' ? parseFloat(value) : value;
								return `$${val.toLocaleString()}`;
							}
						}
					}
				},
				plugins: {
					legend: { display: false },
					title: {
						display: false,
						text: 'Total $ by Category',
						color: '#333',
						font: { size: 18, weight: 'bold' },
						padding: { top: 10, bottom: 20 }
					},
					tooltip: {
						backgroundColor: 'rgba(0, 0, 0, 0.8)',
						titleFont: { size: 16, weight: 'bold' },
						bodyFont: { size: 14 },
						borderColor: '#fff',
						borderWidth: 1,
						callbacks: {
							label: context => `$${context.parsed.y.toLocaleString()}`
						}
					},
					datalabels: {
						color: (ctx) => {
							const value = (ctx as any).raw;
							const yMax = ctx.chart.scales.y.max || 1;
							return value / yMax > 0.2 ? '#fff' : '#000';
						},
						align: (ctx) => {
							const value = (ctx as any).raw;
							const yMax = ctx.chart.scales.y.max || 1;
							return value / yMax > 0.2 ? 'center' : 'end';
						},
						anchor: 'end',
						formatter: (value: number) => `$${value.toLocaleString()}`,
						font: {
							size: 12,
							weight: 'bold'
						},
						clamp: true,
						clip: false,
						rotation: 0
					}
				}
			},
			plugins: [ChartDataLabels]
		});

		this.categoryPieLoading = false;
	}

	renderLineChart() {
		if (!this.linePie) {
			this.linePieLoading = false;
			return;
		}

		if (this.linechart) {
			this.linechart.destroy();
		}

		if (!this.catandlines || !this.catandlines.line_sales) {
			this.linePieLoading = false;
			return;
		}

		const linedata = this.formatData(this.catandlines.line_sales, 'Product Line Sales', false);

		if (this.config.env.package === 'tires') {
			this.labeltype = 'Units';
			this.prefix = false;
		} else {
			this.labeltype = '$';
			this.prefix = true;
		}

		this.linechart = new Chart('plineChart', {
			type: 'bar',
			data: linedata,
			options: {
				indexAxis: 'y',
				responsive: true,
				maintainAspectRatio: false,
				plugins: {
					legend: { display: false },
					title: {
						display: false,
						text: 'Product Line Sales (Last 7 Days)',
						color: '#222',
						font: {
							size: 20,
							weight: 'bold',
							family: 'Segoe UI'
						},
						padding: { top: 10, bottom: 20 }
					},
					tooltip: {
						backgroundColor: '#333',
						titleColor: '#fff',
						bodyColor: '#eee',
						borderColor: '#999',
						borderWidth: 1,
						callbacks: {
							label: (context) => {
								if (this.prefix) {
									return `${this.labeltype}${context.parsed.x.toLocaleString()}`;
								} else {
									return `${context.parsed.x.toLocaleString()} ${this.labeltype}`;
								}
							}
						}
					},
					datalabels: {
						color: '#000',
						anchor: (context) => {
							const value = Number(context.dataset.data[context.dataIndex]);
							const max = context.chart.scales.x.max || 1;
							const chartWidth = context.chart.chartArea.right - context.chart.chartArea.left;
							const pxValue = (value / max) * chartWidth;
							return pxValue > 80 ? 'center' : 'end';
						},
						align: (context) => {
							const value = Number(context.dataset.data[context.dataIndex]);
							const max = context.chart.scales.x.max || 1;
							const chartWidth = context.chart.chartArea.right - context.chart.chartArea.left;
							const pxValue = (value / max) * chartWidth;
							return pxValue > 80 ? 'center' : 'right';
						},
						formatter: (value) => {
							if (this.prefix) {
								return `${this.labeltype}${value.toLocaleString()}`;
							} else {
								return `${value.toLocaleString()} ${this.labeltype}`;
							}
						},
						font: {
							size: 13,
							weight: 'bold'
						},
						clip: false
					}
				},
				scales: {
					x: {
						beginAtZero: true,
						ticks: {
							color: '#444',
							callback: (value) => {
								if (this.prefix) {
									return `${this.labeltype}${value}`;
								} else {
									return `${value} ${this.labeltype}`;
								}
							}
						},
						grid: { color: '#eee' }
					},
					y: {
						ticks: {
							color: '#444',
							font: { size: 14 }
						},
						grid: { display: false }
					}
				},
				animation: {
					duration: 800,
					easing: 'easeOutQuart'
				}
			},
			plugins: [ChartDataLabels]
		});

		this.linePieLoading = false;
	}

	renderCustomerTypeChart() {
		// New: SVG donut — build slices, no canvas/Chart.js needed.
		this.buildCustomerTypeSlices();
		this.categoryPieLoading = false;
		return;
		/* eslint-disable */
		// Legacy Chart.js path retained below in case anything still relies on it.
		if (!this.customerTypePie) {
			return;
		}

		if (this.customerTypeChart) {
			this.customerTypeChart.destroy();
		}

		this.cdr.detectChanges();

		const canvas = this.customerTypeChartRef?.nativeElement;
		if (!canvas) {
			return;
		}

		const ctx = canvas.getContext('2d');
		if (!ctx) {
			console.error('Canvas context not found');
			return;
		}

		this.customerTypeChart = new Chart(ctx, {
			type: 'bar', //  Horizontal bar chart
			data: this.getCustomerTypeChartData(),
			options: {
				indexAxis: 'y', //  Horizontal bar chart
				// responsive: true,
				// maintainAspectRatio: false,  //  Allows better scaling
				layout: {
					padding: { left: 10, right: 20, top: 10, bottom: 10 } //  Prevents label clipping
				},
				scales: {
					x: {
						beginAtZero: true,
						title: {
							display: true,
							text: 'Total Sales (Units)',
							color: '#333',
							font: {
								size: 14,
								weight: 'bold'
							}
						},
						ticks: {
							autoSkip: false, //  Prevents skipping of values
							maxRotation: 45, //  Rotates labels to 45 degrees
							minRotation: 45 //  Ensures labels always stay rotated
						},
						grid: {
							color: 'rgba(200, 200, 200, 0.3)' //  Clean grid lines
						}
					},
					y: {
						title: {
							display: true,
							text: 'Customer Type',
							color: '#333',
							font: {
								size: 14,
								weight: 'bold'
							}
						},
						ticks: {
							font: {
								size: 12, //  Adjust label size for better fit
								weight: 'bold'
							},
							padding: 5 //  Adds spacing between labels & bars
						},
						grid: {
							display: false //  Hide y-axis grid for cleaner look
						}
					}
				},
				plugins: {
					legend: {
						display: false //  Hide legend for cleaner look
					},
					title: {
						display: false,
						text: 'Customer Type Sales',
						font: {
							size: 16,
							weight: 'bold'
						},
						color: '#333'
					},
					tooltip: {
						callbacks: {
							label: (tooltipItem: any) => {
								const label = tooltipItem.label || '';
								const value = tooltipItem.raw || 0;
								return `${label}: ${value} units`;
							}
						}
					}
				}
			}
		});


	}

	/**  Function to structure chart data **/
	getCustomerTypeChartData() {
		const colors = [
			'#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40'
		]; //  Custom color palette

		return {
			labels: this.customerTypeSales.map(item => item.label),
			datasets: [
				{
					label: 'Total Sales (Units)',
					data: this.customerTypeSales.map(item => item.qty), //  Using `qty`
					backgroundColor: this.customerTypeSales.map((_, i) => colors[i % colors.length]), //  Dynamic colors
					borderColor: this.customerTypeSales.map((_, i) => colors[i % colors.length]),
					borderWidth: 1,
					borderRadius: 8, //  Rounded edges
					hoverBackgroundColor: this.customerTypeSales.map((_, i) => this.adjustColorBrightness(colors[i % colors.length], 30)), //  Slightly brighter on hover
					hoverBorderColor: this.customerTypeSales.map((_, i) => this.adjustColorBrightness(colors[i % colors.length], -20)) //  Slightly darker border
				}]
		};
	}

	adjustColorBrightness(hex: string, percent: number): string {
		const num = parseInt(hex.replace('#', ''), 16);
		let r = (num >> 16) + percent;
		let g = ((num >> 8) & 0x00FF) + percent;
		let b = (num & 0x0000FF) + percent;

		r = Math.min(255, Math.max(0, r));
		g = Math.min(255, Math.max(0, g));
		b = Math.min(255, Math.max(0, b));

		return `rgb(${r}, ${g}, ${b})`;
	}


	getCatLabelData(label){
		this.labelViewing = label
		this.showLabelData = false;
		this.labelData = false;
		if(this.labelLoading){
			this.labelLoading = false;
		}

		// Unsubscribe previous subscription if exists
		if (this.labelLoading && typeof this.labelLoading.unsubscribe === 'function') {
			this.labelLoading.unsubscribe();
		}
		this.labelLoading = this.dashboardService.getNonStockData(label).pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
			this.labelLoading = false;
			let nonstock;
			if(this.config.env.package == 'beauty'){
				nonstock = 'UNKOWN';
			}else{
				nonstock = this.config.features.nonstockitem;
			}

			if(res.success){
				let headers = ['Cust.', 'Orderno', 'SKU', 'Desc.', 'Date', 'By','Qty', 'Total' ]
				if(label === nonstock){
					if(this.config.env.package === 'tires'){
						headers =  ['Cust.','Orderno', 'Desc', 'Date.', 'By','Supplier', 'Partno', 'Designation','Qty', 'Total' ];
					}else{
						headers =  ['Cust.','Orderno', 'Desc', 'Date.', 'By','Supplier', 'Partno', 'Qty', 'Total' ];
					}
				}

				let html = '<table class="table table-striped w-100"><thead><tr>';
				headers.forEach((v) => {
					if(['total','qty'].includes(v)){
						html += '<th class="text-right">' + v + '</th>'
					}else{
						html += '<th class="text-left">' + v + '</th>'
					}
				})
				html += '</tr></thead><tbody>'
				res.data.forEach((row) => {
					const date = new Date(row['trandate']);

					html += '<tr><td class="text-left" (click)="navigateToCustomer(row["debtorno"])"><span class="link">' + row['debtorno']+ '.' + row['branchcode']  + '</span></td>'
					html += '<td class="text-left">' + row['orderno'] + '</td>'

					if(label !== nonstock){ html += '<td class="text-left">' + row['stockid']  + '</td>' }

					html += '<td class="text-left">' + (row['itemdesc'] ? row['itemdesc'] : '-') + '</td>'
					html += '<td class="text-left">' + `${date.getMonth()+1}/${date.getDate()}/${date.getFullYear()}` + '</td>'
					html += '<td class="text-left">' + (row['enteredby'] ? row['enteredby'] : '-') + '</td>'

					if(label === nonstock){
						html += '<td class="text-left">' + row['supplierno'] + ' : ' + row['suppname'] + '</td>'
						html += '<td class="text-left">' + row['suppliers_partno'] + '</td>'
						if(this.config.env.package === 'tires'){
							html += '<td class="text-left">' + row['designation'] + '</td>'
						}
					}

					html += '<td class="text-right">' + row['qty'] + '</td>'
					html += '<td class="text-right">' + row['total'] + '</td></tr>'
				})
				html += '</tbody></table>';
				this.labelData = html;
				this.showLabelData = true;
			}else{
				this.labelData = false;
				this.showLabelData = false;
			}
		});

	}

	navigateToCustomer(debtorno){
		if(debtorno){
			this.router.navigate(['./customers/view/' + debtorno]);
		}
	}



	exportXls(input: any = false) {
		const now = new Date();
		let element = this.printtable?.nativeElement.innerHTML ?? '';
		let filename = 'ThisLast '
		if(input){
			element = input['html'];
			filename = input['name'];
		}
		const encoded: string = this.globalSearchService.base64encode(element);
		const data = {
			content: encoded,
			filename: filename + (now.getMonth() + 1) + now.getDate() + now.getFullYear(),
			//title: `This/Last - Created @ ${now.toLocaleString()}`,
			//subtitle: ''
		}

		this.printService.xls(data).pipe(takeUntil(this.destroy$)).subscribe((result: any) => {
			this.globalSearchService.downloadXls(result.content, data.filename);
		});
	}

	exportPdf(input: any = false) {
		const now = new Date();
		let element = this.printtable?.nativeElement.innerHTML ?? '';
		let filename = 'ThisLast '
		let title = 'This/Last';
		if(input){
			element = input['html'];
			filename = input['name'];
			title = filename;
		}
		const encoded: string = this.globalSearchService.base64encode(element);
		const data = {
			content: encoded,
			filename: filename + (now.getMonth() + 1) + now.getDate() + now.getFullYear(),
			title: `${title} - Created @ ${now.toLocaleString()}`,
			subtitle: '',
		}

		this.printService.pdf(data).pipe(takeUntil(this.destroy$)).subscribe((result: any) => {
			this.globalSearchService.downloadPdf(result.content, data.filename);
		});
	}

}